import {
  IAriyaMonitorData,
  IHandraisersByCity,
  IHandraisersConversion,
  IHandraisersNAE,
  IHandraisersRegionSplit,
  IPopularData,
} from "../../constants/interface/ariya";
import { postDataV2 } from "../utils";
import { apiPrefix, apiPrefix_Dp, ariyaPrefix } from "./constants";

export const fetchHandraiserNAEData = (): Promise<IHandraisersNAE> => postDataV2(`${apiPrefix}/NAEHandRaisersTrendGraph_for_testing`, {});
export const fetchHandraiserNAEData_Total = (): Promise<IAriyaMonitorData> => postDataV2(`${apiPrefix_Dp}/ariya_hand_raisers`, {});
export const fetchGradesData = (): Promise<IPopularData> => postDataV2(`${apiPrefix}/NAETopThreeGrades_for_testing`, {});
export const fetchColoursData = (): Promise<IPopularData> => postDataV2(`${apiPrefix}/NAETopThreeColors_for_testing`, {});
export const fetchHandraisersConversionData = (): Promise<IHandraisersConversion> =>
  postDataV2(`${apiPrefix}/HandraisersConversion_for_testing`, {});
export const fetchHandraisersConversionData_Nov_2021 = (): Promise<IHandraisersConversion> =>
  postDataV2(`${apiPrefix}/HandraisersConversion_for_testing_nov_2021`, {});
export const fetchHandraisersCityBreakdownData = (): Promise<IHandraisersByCity> => postDataV2(`${apiPrefix}/handraisersGeoCountryAll`, {});
export const fetchHandraisersRegionSplitData = (): Promise<IHandraisersRegionSplit> =>
  postDataV2(`${ariyaPrefix}/handRaisersRegionSplitOverallNumber_for_testing`, {});
